//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





import UMUM from "../../library/umum";
import DATA_MASTER from "../../library/dataMaster";


export default {
  props: ["biodata_id", "nip"],
  data() {
    
    return {
      // xbiodata_id : this.biodata_id,
      list_riwayat: [],
      list_pendidikan :[],
      pendidikan : {
        diklat_struktural_id : '',
        jns_diklat_id : '1',
        jns_latihan_struktural_id : '',
        jns_kompetensi_id : '13',
        uraian : '',
        angkatan : '',
        penyelenggara : '',
        tgl_mulai : '',
        tgl_selesai : '',
        jumlah_jam : 0,
        predikat : '',
        lokasi_pendidikan : '',
        no_ijazah : '',
        idPns : '',
        biodata_id : this.biodata_id,
        status : 1,
        file : null,
        userId : '',
        createdAt : '',
      },

      dummy : {
        jns_latihan_struktural_id : null,
      },


      mdl_detil_riwayat: false,
      mdl_detil_riwayat_add: false,
      mdl_detil_riwayat_add_lampiran: false,
      mdl_detil_riwayat_edit: false,
      mdl_detil_riwayat_hapus: false,
      file_old :'',

      UMUM: UMUM,
      DATA_MASTER: DATA_MASTER,

      btn_add: false,


      tab: 'disetujui',


      loadRiwayatSIA : true,
      fileLoadSIA :true,
      fileLoadEmpty : false,
      fileRiwayat : null,
      kodeDok : '874',


      status :1,



    };
  },

  methods: {
    getRiwayat: function(){

      this.loadRiwayatSIA = true;


        fetch(this.$store.state.url.URL_simpeg_diklat_struktural+'view', {
            method : 'POST',
            headers : {
              "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
            },
            body : JSON.stringify({
              biodata_id : this.pendidikan.biodata_id,
              status : this.status
            })
        }).then((res) => res.json()).then((res_data) => {
          this.list_pendidikan = res_data;
          this.loadRiwayatSIA = false;
          // console.log(res_data);
        })
    },

    addData : function(number) {


      var formData = new FormData();
      formData.append('diklat_struktural_id', this.pendidikan.diklat_struktural_id);
      formData.append('jns_diklat_id', this.pendidikan.jns_diklat_id);
      formData.append('jns_latihan_struktural_id', this.pendidikan.jns_latihan_struktural_id);
      formData.append('jns_kompetensi_id', this.pendidikan.jns_kompetensi_id);
      formData.append('uraian', this.pendidikan.uraian);
      formData.append('angkatan', this.pendidikan.angkatan);
      formData.append('penyelenggara', this.pendidikan.penyelenggara);
      formData.append('tgl_mulai', this.pendidikan.tgl_mulai);
      formData.append('tgl_selesai', this.pendidikan.tgl_selesai);
      formData.append('jumlah_jam', this.pendidikan.jumlah_jam);
      formData.append('predikat', this.pendidikan.predikat);
      formData.append('lokasi_pendidikan', this.pendidikan.lokasi_pendidikan);
      formData.append('no_ijazah', this.pendidikan.no_ijazah);
      formData.append('biodata_id', this.pendidikan.biodata_id);

      formData.append('nip', this.nip);
      formData.append('kode', this.kodeDok);



      formData.append('file', this.pendidikan.file);

      fetch(this.$store.state.url.URL_simpeg_diklat_struktural+'createData', {
          method: "POST",
          headers: {
              authorization : 'kikensbatara '+localStorage.token
          },
          body: formData
      }).then(res => res.json()).then((data_urusan) => {
          this.Notify('Sukses Menambah Data', 'primary', 'check_circle_outline');
          this.getRiwayat();
      });
     
    },


    editData : function(){

      var formData = new FormData();
      formData.append('diklat_struktural_id', this.pendidikan.diklat_struktural_id);
      formData.append('jns_latihan_struktural_id', this.pendidikan.jns_latihan_struktural_id);
      formData.append('angkatan', this.pendidikan.angkatan);
      formData.append('penyelenggara', this.pendidikan.penyelenggara);
      formData.append('tgl_mulai', this.pendidikan.tgl_mulai);
      formData.append('tgl_selesai', this.pendidikan.tgl_selesai);
      formData.append('jumlah_jam', this.pendidikan.jumlah_jam);
      formData.append('predikat', this.pendidikan.predikat);
      formData.append('lokasi_pendidikan', this.pendidikan.lokasi_pendidikan);
      formData.append('no_ijazah', this.pendidikan.no_ijazah);
      formData.append('biodata_id', this.pendidikan.biodata_id);
      formData.append('file', this.pendidikan.file);
      formData.append('file_old', this.file_old);

      fetch(this.$store.state.url.URL_simpeg_diklat_struktural+'updateData', {
          method: "POST",
          headers: {
              authorization : 'kikensbatara '+localStorage.token
          },
          body: formData
      }).then((res_data) => {
          this.Notify('Sukses Merubah Data', 'warning', 'check_circle_outline');
          this.getRiwayat();
      });
    },

    removeData : function(E){
      fetch(this.$store.state.url.URL_simpeg_diklat_struktural + "removeData", {
          method: "POST",
          headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify({id : this.pendidikan.diklat_struktural_id, file : this.file_old})
      }).then(res_data => {
          this.Notify('Sukses Menghapus Data', 'negative', 'check_circle_outline');
          this.getRiwayat();
      });

    },

    selectRiwayat: function(data){

          this.pendidikan.diklat_struktural_id = data.diklat_struktural_id;
          this.pendidikan.jns_diklat_id = data.jns_diklat_id,
          this.pendidikan.jns_latihan_struktural_id = data.jns_latihan_struktural_id;
          this.pendidikan.jns_kompetensi_id = data.jenisKompetensi;
          this.pendidikan.uraian = data.uraian;
          this.pendidikan.angkatan = data.angkatan;
          this.pendidikan.penyelenggara = data.penyelenggara;
          this.pendidikan.tgl_mulai = data.tgl_mulai;
          this.pendidikan.tgl_selesai = data.tgl_selesai;
          this.pendidikan.jumlah_jam = data.jumlah_jam;
          this.pendidikan.predikat = data.predikat;
          this.pendidikan.lokasi_pendidikan = data.lokasi_pendidikan;
          this.pendidikan.no_ijazah = data.no_ijazah;
          this.pendidikan.idPns = data.idPns;
          this.pendidikan.status = data.status;


          this.pendidikan.nm_diklat = data.nm_diklat;
          this.pendidikan.tpt_belajar = data.tpt_belajar;
          this.pendidikan.jumlah_jam = data.jumlah_jam;
          this.pendidikan.createdAt = data.createdAt;



          if (data.status != 1) {
            this.fileLoadSIA = false
            this.file_old = data.path[this.kodeDok].realname;
          }

          



          console.log(data);

    },


    // assu : function(){
    //   console.log("aaaassssuuuu");
    // },



    // ====================================== INTEGRASI SI-ASN ====================================


    syncDataRiwayatSiASN: function(){

        this.loadRiwayatSIA = true;


        fetch(this.$store.state.url.URL_simpeg_diklat_struktural+'si_asn_viewOne', {
            method : 'POST',
            headers : {
              "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
            },
            body : JSON.stringify({
              nip : this.nip,
              biodata_id : this.biodata_id,
              kode : this.kodeDok,
            })
        }).then((res) => res.json()).then((res_data) => {
          this.Notify('Sukses Sync Data', 'warning', 'check_circle_outline');


          this.getRiwayat();

          this.loadRiwayatSIA = false;
          // console.log(res_data);
        })
    },

    approveUsulanDataRiwayatSiASN : async function(){


      this.pendidikan.nip = this.nip
      this.pendidikan.kode = this.kodeDok
      this.pendidikan.file_old = this.file_old

      var sex = await UMUM.alertConfirm("Integrasi Usulan", "Apakah anda yakin ?!")

      if (sex.isConfirmed) {

        


        fetch(this.$store.state.url.URL_simpeg_diklat_struktural + "approve", {
            method: "POST",
            headers: {
              "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify(this.pendidikan)
        }).then(res_data => {
            this.Notify('Sukses approve Data', 'primary', 'check_circle_outline');
            this.getRiwayat();
        });


              
      }



    },

    deleteDataRiwayatSiASN : async function(){


      this.pendidikan.nip = this.nip
      this.pendidikan.kode = this.kodeDok

      var sex = await UMUM.alertConfirm("Integrasi Usulan", "Apakah anda yakin ?!")

      if (sex.isConfirmed) {

        


        fetch(this.$store.state.url.URL_simpeg_diklat_struktural + "si_asn_delete", {
            method: "POST",
            headers: {
              "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify(this.pendidikan)
        }).then(res_data => {
            this.Notify('Sukses menghapus Data', 'primary', 'check_circle_outline');
            this.getRiwayat();
        });


              
      }



    },


    getDownloadSIASN: async function(file,kode) {


      console.log("ppppppppp");
      console.log(file);
      console.log("ppppppppp");

              
      if (file.path == null || file.path == undefined) {
        this.fileLoadEmpty = true
        console.log("FILE KOSONG");
      } else {
        this.fileLoadEmpty = false


        console.log(file);
        
        var fileGet = file.path[kode].dok_uri
        this.fileLoadSIA = true
        fetch(this.$store.state.url.URL_simpeg_home + "lampiran", {
            method: "POST",
            headers: {
                "content-type": "application/json",
                authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify({
                fileURL: fileGet,
                id : file.diklat_struktural_id,
                kode : this.kodeDok,
            })
            })
            .then(response => response.text())
            .then(res_data => {


                console.log("INI DIA");
                console.log(res_data)
                console.log("INI DIA");
                console.log(typeof(res_data));

                this.fileRiwayat = res_data
                this.fileLoadSIA = false

              

        });




      }


    },



    cchontol(){

      if (this.pendidikan.jns_diklat_id != '1') {
        this.pendidikan.jns_latihan_struktural_id = '0'
      }
      console.log(this.pendidikan.jns_latihan_struktural_id);
    },

    cchontol1(){
      console.log(this.dummy.jns_latihan_struktural_id);
      this.pendidikan.uraian = this.dummy.jns_latihan_struktural_id.jns_latihan_struktural
      this.pendidikan.jns_latihan_struktural_id = this.dummy.jns_latihan_struktural_id.jns_latihan_struktural_id
    },



    // ====================================== INTEGRASI SI-ASN ====================================



    alertku: function(message, positive, icon) {
        this.$q.notify({
          message: message,
          color: positive,
          icon: icon,
          position: "top",
          timeout: 500
        });
    },
    Notify: function(message, positive, icon) {
      this.$q.notify({
        message: message,
        color: positive,
        icon: icon,
        position: "top",
        timeout: 500
      });
    },

  },


  mounted () {
    this.getRiwayat()
    DATA_MASTER.getGolongan();
    DATA_MASTER.getJnsDiklat();
    DATA_MASTER.getLatStruktural();
    DATA_MASTER.getJnsKompetensi();
  },



};
